export default __webpack_public_path__ + "static/media/file-default_darkGray3.b922dad4.svg";